export const STATES = {
  REVEALED: 'phxsg-is-revealed',
  SPLITTED: 'phxsg-is-splitted',
} as const;
